export default __webpack_public_path__ + "static/media/007-plant.dc5e2501.svg";